<template>
  <div class="mt-2">
    <v-toolbar
      class="elevation-1 white--text"
      color="primary"
      height="50px"
    >
      <v-toolbar-title>
        <v-icon class="white--text">fa-users</v-icon>
        Teams
      </v-toolbar-title>
      <v-divider
        class="mx-2"
        inset
        vertical
      />
      <v-spacer />
      <AddTeamDialog />
      <EditTeamDialog />
    </v-toolbar>
    <v-data-table
      :headers="teamTableHeaders"
      :items="teamList"
      class="elevation-1"
      v-if="teamList !== undefined"
    >
      <template
        slot="item"
        slot-scope="props"
      >
        <tr>
          <td class="text-xs-left">
            {{ props.item.name }}
          </td>
          <td class="text-xs-left">
            {{ props.item.isActive ? "Y" : "N" }}
          </td>
          <td class="justify-center layout px-0">
            <v-icon
              @click="editItem(props.item)"
              class="mr-2"
              small
              style="display: inline-flex;"
            >
              edit
            </v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from "vuex";
    import {alphaNum, required} from 'vuelidate/lib/validators'
    import EditTableFunctions from './../../../components/editTableFunctions';
    import {LOAD_TEAM_TO_EDIT, TOGGLE_EDIT_TEAM_DIALOG} from "./../../../store/team/mutations.js";
    import {FETCH_TEAM_LIST} from "./../../../store/team/actions.js";
    import EditTeamDialog from "./EditTeamDialog";
    import AddTeamDialog from "./AddTeamDialog";

    export default {

        validations: {
            teamName: {required, alphaNum} // rules object
        },
        components: {
            AddTeamDialog,
            EditTeamDialog
        },
        mixins: [
            EditTableFunctions,
        ],
        data() {
            return {
                dialog: false,
                breadcrumbPath: [{text: process.env.VUE_APP_SYSTEM_NAME, to: "/"}, {text: 'Manage Teams', disabled: true,}],
                loading: true,
                personnelWithTeamTitle: [],
                selectedPersonnelId: '',
                teamId: '',
                chosenPerson: {},
                teamTableHeaders: [
                    {
                        text: 'Name',
                        align: 'left',
                        value: 'name'
                    },
                    {
                        text: 'Is Live',
                        align: 'left',
                        value: 'isActive'
                    },
                    {text: 'Actions', align: 'center', value: 'name', sortable: false}
                ],
                rowsPerPageItems: [10, 20, 50, {"text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1}],
                pagination: {
                    rowsPerPage: 10
                },
                editedId: -1,
                idName: 'teamId',
            };
        },
        computed: {
            ...mapGetters(
            [
                "teamList",
            ]
            ),
            newTeamName: {
                get() {
                    return this.$store.state.team.newTeam.name;
                },
                set(value) {
                    this.updateValue('name', value);
                },
            },
        },
        mounted() {
            this.fetchAllTableItems();

            if (
            this.$route.params !== undefined
            && this.$route.params.teamId !== undefined) {
                this.teamId = this.$route.params.teamId;

            }
        },
        methods: {
            ...mapActions({
                fetchTableList: FETCH_TEAM_LIST,
            }),

            ...mapMutations({
                toggleEditDialog: TOGGLE_EDIT_TEAM_DIALOG,
                loadTableItemToEdit: LOAD_TEAM_TO_EDIT,
            })
        },
    }
</script>

<style scoped>
  #teamTable {
    width: 100%;
    text-align: left;
    padding-left: 16px;
  }

  #teamTable th,
  #teamTable td {
    text-align: left;
  }
</style>
